<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1000" v-model="isOpenDialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          Nhập EXCEL <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5 border">
          <div class="wrap">
            <div
              class="d-flex flex-column justify-center align-center mx-auto"
              style="width: 330px; min-height: 320px"
              v-if="step === 'import'"
            >
              <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
              <div class="text-center content-text mt-5" @click="exportExcelTemplate">
                Tải tệp Excel (.xlsx) chứa danh sách học sinh
              </div>
              <div class="mt-5">
                <v-btn color="primary" class="mr-5" @click="exportExcelTemplate" outlined>Tải mẫu nhập</v-btn>
                <v-btn color="primary" class="elevation-0 white--text" :loading="isSelecting" @click="onExcelUpload">
                  <span class="white--text">Chọn tệp</span>
                  <input
                    ref="uploader"
                    type="file"
                    class="d-none"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="onFileChanged"
                  />
                </v-btn>
              </div>
            </div>
            <tableImportStudent
              :file="selectedFile.name"
              @reset="resetInput"
              v-else-if="step === 'send'"
              :isError="isError"
            ></tableImportStudent>
          </div>
        </v-card-text>
        <hr color="#E0E0E0" />
        <v-card-actions>
          <v-btn class="ma-2" width="100px" outlined light depressed @click="cancel">Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" width="100px" dark depressed :color="colorButtonSave" @click="save">Lưu</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import { mapActions, mapMutations, mapState } from 'vuex'
import alert from '@/plugins/alert'

import tableImportStudent from './tableImportStudent.vue'
const schema = {
  'Mã số': {
    prop: 'code',
    type: String
  },
  'Tên học sinh': {
    prop: 'name',
    type: String
  },
  'Ngày sinh': {
    prop: 'dob',
    type: String
  },
  'Giới tính': {
    prop: 'gender',
    type: String
  },
  Lớp: {
    prop: 'class',
    type: String
  },
  'Trạng thái': {
    prop: 'status',
    type: String
  }
}

export default {
  components: {
    tableImportStudent
  },
  data() {
    return {
      isOpenDialog: false,
      progress: 1,
      isSelecting: false,
      selectedFile: null,
      step: 'import',
      colorButtonSave: '#E0E0E0',
      isError: false
    }
  },
  computed: {
    ...mapState('tuitionFeeGroupStudent', ['selectedStudent'])
  },
  methods: {
    ...mapActions('tuitionFeeGroupStudent', ['removeAllStudentInGroup', 'addStudentImport']),
    ...mapMutations('tuitionFeeGroupStudent', ['setSelectedStudent']),
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    exportExcelTemplate() {
      this.$loading.active = true
      window.location.href = `${window.location.origin}/Danh sách HS vào nhóm đối tượng.xlsx`
      this.$loading.active = false
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        this.$alert.error({
          title: 'File không có định dạng.',
          description: 'xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)'
        })
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.step = 'send'
        this.colorButtonSave = '#0D47A1'
        this.setSelectedStudent(results)
      }
      this.$loading.active = false
    },
    cancel() {
      this.isOpenDialog = false
      this.resetInput()
    },
    openDialog() {
      this.isOpenDialog = true
    },
    async save() {
      if (this.selectedStudent[0] && !this.isError) {
        this.$loadingCount.start({ count: 0, total: this.selectedStudent.length, msg: 'Đang tải lên', postfix: 'học sinh' })
        await this.removeAllStudentInGroup(this.$route.params.id)
        let arr = await this.addStudentImport(this.selectedStudent)
        if (arr[0]) {
          this.isError = true
          let studentError = []
          for (let i = 0; i < this.selectedStudent.length; i++) {
            if (arr.includes(this.selectedStudent[i].code)) {
              studentError.unshift({
                ...this.selectedStudent[i],
                index: i + 1
              })
            }
          }
          this.setSelectedStudent(studentError)
          this.colorButtonSave = '#E0E0E0'
        } else {
          this.resetInput()
          alert.success('Đã tải file lên thành công!')
          this.isOpenDialog = false
        }
        this.$loadingCount.end()
      }
    },
    resetInput() {
      this.step = 'import'
      this.selectedFile = null
      this.colorButtonSave = '#E0E0E0'
      this.setSelectedStudent([])
      this.isError = false
    }
  }
}
</script>
<style>
.wrap {
  border: 1px solid rgb(222, 222, 222);
  border-radius: 4px;
}
</style>
